<template>
  <div v-if="!!phaseData">
    <div class="d-flex gap-8 align-end flex-wrap">
      <select-printing-template v-model="selectedTemplate" type="report" style="max-width: 400px" />
      <v-btn color="primary" :disabled="!report || report.length === 0" :loading="printing" @click="printPdf">
        Imprimir
      </v-btn>
    </div>
    <field-label class="mt-8" label="Anotações">
      <text-area :readonly="disabled" :max-length="2000" v-model="report" :key="'report' + phaseKey" />
    </field-label>
    <field-label class="mt-8" label="CIDs e sintomas">
      <search-server-field v-model="phaseData.symptoms" multiple :path="'cid-symptom'" />
    </field-label>
  </div>
</template>
<script>
import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'
import TextArea from '@/components/TextArea.vue'
import FieldLabel from '@/components/FieldLabel.vue'
import SearchServerField from '@/components/SearchServerField.vue'

import { createNamespacedHelpers } from 'vuex'
import { STATUS_FINISHED } from '@/constants/attendance'
import SelectPrintingTemplate from '@/components/PrintingTemplate/SelectPrintingTemplate.vue'
const { mapGetters: attendanceGettersMap, mapActions: attendanceActionsMap } = createNamespacedHelpers('attendance')
export default {
  components: {
    TextArea,
    FieldLabel,
    SearchServerField,
    SelectPrintingTemplate,
  },
  extends: BasePhase,
  data() {
    return {
      report: null,
      selectedTemplate: null,
      printing: false,
    }
  },
  computed: {
    ...attendanceActionsMap(['setAttendanceMedicalReport', 'setAttendanceMedicalReportReferences']),
    ...attendanceGettersMap(['attendance', 'attendanceId']),
    isFinishedAttendance() {
      return this.attendance?.status === STATUS_FINISHED.value
    },
    printReportUrl() {
      return `${this.$util.apiURL()}/attendance/report/print/${this.attendance.id}/`
    },
  },
  methods: {
    ...attendanceActionsMap(['startServerSyncing', 'endServerSyncing']),
    async printPdf() {
      await this.saveReport()
      try {
        this.printing = true
        const blob = await this.$api.printingTemplate.print({
          templateId: this.selectedTemplate.id,
          patientId: this.attendance.patient.id,
          text: this.report,
          extraText: this.references,
        })
        this.$util.downloadBlob(blob, 'relatório.pdf')
      } catch (error) {
        this.$root.error(error)
      } finally {
        this.printing = false
      }
    },
    getDefaultData() {
      const data = {
        symptoms: [],
        notes: null,
        report: null,
      }
      return data
    },

    async saveMedicalDocument() {
      const data = {
        report: this.report,
        references: this.references,
      }
      return this.$api.medicalDocument.create({
        patientId: this.attendance.patient.id,
        kind: 'report',
        data,
        templateId: this.selectedTemplate.id,
        attendanceId: this.attendance.id,
      })
    },

    async saveReport() {
      try {
        await this.saveMedicalDocument()
      } catch (e) {
        console.error(e)
      }

      if (this.isServerSyncedData || this.isSavingData) {
        return
      }

      try {
        await this.startServerSyncing()
        await this.$api.patchAttendance(this.attendance.id, this.attendance)
        await this.endServerSyncing(true)
      } catch (error) {
        await this.endServerSyncing(false)
        if (showError) {
          this.$root.error(error)
        } else {
          this.$logger.warn('Não foi possível salvar os dados do atendimento no servidor!', error)
        }
      }
    },
  },
}
</script>

<style scoped></style>
